import exp from "constants";
import MainNavigation from "../../components/Navigation/MainNavigation";
import SectionNine from "./SectionNine";
import React from "react";

function Refund() {
     const [hover, setHover] = React.useState(false);
  return (
      <><><MainNavigation /><div style={styles.page}>

          <div style={styles.container}>
              <div style={styles.card}>
                  {/* Header */}
                  <div style={styles.header}>
                      <p style={styles.updated}>Last updated on 19/01/2025</p>
                      <h1 style={styles.title}>Refund Policy</h1>

                      <p style={styles.intro}>
                          At DataUp Gaming, we strive to provide a seamless and enjoyable
                          experience for our users. Please review our refund policy carefully.
                      </p>
                  </div>

                  {/* Returns & Refunds Policy */}
                  <section style={styles.section}>
                      <h2 style={styles.sectionTitle}>Returns &amp; Refunds Policy</h2>
                      <ul style={styles.list}>
                          <li style={styles.listItem}>
                              The purchase of any digital assets, including gift card vouchers,
                              is final and non-refundable.
                          </li>
                          <li style={styles.listItem}>
                              If you experience technical issues with your gift card voucher,
                              please contact our customer support team immediately for assistance.
                              We are committed to resolving any valid technical concerns promptly.
                          </li>
                      </ul>
                  </section>

                  {/* Return Policy */}
                  <section style={styles.section}>
                      <h2 style={styles.sectionTitle}>Return Policy</h2>
                      <ul style={styles.list}>
                          <li style={styles.listItem}>
                              All gift card vouchers and digital purchases are non-returnable and
                              cannot be returned or exchanged for cash, goods, or services.
                          </li>
                      </ul>
                  </section>

                  {/* Exceptions */}
                  <section style={styles.section}>
                      <h2 style={styles.sectionTitle}>Exceptions</h2>
                      <ul style={styles.list}>
                          <li style={styles.listItem}>
                              Refunds may be granted only in cases where technical issues make the
                              gift card voucher or digital purchase completely unusable, as determined
                              by our support team.
                          </li>
                          <li style={styles.listItem}>
                              Any refund or resolution offered is at the sole discretion of DataUp Gaming.
                          </li>

                      </ul>

                      <div style={styles.noteBox}>
                          <p style={styles.noteText}>
                              For more information, please refer to our Terms and Conditions or contact our
                              support team at{" "}
                              <a
                                  href="mailto:support@dataupgaming.com"
                                  style={hover ? { ...styles.link, textDecoration: "underline" } : styles.link}
                                  onMouseEnter={() => setHover(true)}
                                  onMouseLeave={() => setHover(false)}
                              >
                                  support@dataupgaming.com
                              </a>
                              .
                          </p>
                      </div>
                  </section>

                  <p style={styles.footer}>
                      DataUp Gaming — Refund decisions for technical issues are handled by our support team.
                  </p>
              </div>
          </div>
      </div></><SectionNine /></>
  );
}

export default Refund;

const styles: Record<string, React.CSSProperties> = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#F7F8FA",
    padding: "56px 16px",
    color: "#101828",
    fontFamily:
      'ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial',
  },
  container: {
    maxWidth: 960,
    margin: "0 auto",
  },
  card: {
    backgroundColor: "#FFFFFF",
    borderRadius: 18,
    border: "1px solid #EAECF0",
    boxShadow: "0 14px 40px rgba(16, 24, 40, 0.08)",
    padding: "28px 22px",
  },
  header: {
    textAlign: "center",
    marginBottom: 22,
  },
  updated: {
    fontSize: 13,
    color: "#667085",
    fontWeight: 600,
    margin: 0,
  },
  title: {
    fontSize: 36,
    fontWeight: 800,
    margin: "10px 0 0",
  },
  intro: {
    fontSize: 15.5,
    lineHeight: 1.75,
    color: "#344054",
    marginTop: 16,
    textAlign: "center",
  },
  section: {
    marginTop: 26,
  },
  sectionTitle: {
    fontSize: 20,
    fontWeight: 800,
    marginBottom: 10,
  },
  paragraph: {
    fontSize: 15.5,
    lineHeight: 1.75,
    marginBottom: 12,
    color: "#344054",
  },
  list: {
    paddingLeft: 22,
    marginBottom: 14,
  },
  listItem: {
    marginBottom: 8,
    fontSize: 15.5,
    lineHeight: 1.75,
    color: "#344054",
  },
  noteBox: {
    marginTop: 18,
    padding: 14,
    backgroundColor: "#F2F4F7",
    border: "1px solid #EAECF0",
    borderRadius: 12,
  },
  noteText: {
    margin: 0,
    fontSize: 14.5,
    lineHeight: 1.7,
    color: "#101828",
    fontWeight: 600,
  },
  contactBox: {
    marginTop: 14,
    padding: 14,
    backgroundColor: "#E6F5FE",
    border: "1px solid #B7E2FA",
    borderRadius: 12,
  },
  link: {
    color: "#027EC2",
    fontWeight: 700,
    textDecoration: "none",
  },
  footer: {
    marginTop: 18,
    fontSize: 13,
    color: "#667085",
    textAlign: "center",
  },
};
